import * as React from 'react';

import classnames from 'classnames';

import {Title} from 'shells/typography/title';
import {TitleWithBody} from 'shells/typography/title-with-body';

import styles from '../competitors.module.css';

type Props = {
    headerTitle: string;
    headerBody: string;
    headerRight?: React.ReactNode;
    downloadReportTitle: string;
};

export function ChartHeader(props: Props) {
    return (
        <div>
            {/* This is visible in the UI, removed for the downloaded report */}
            <div
                className={classnames(
                    'flex justify-sb report-chart-ui-header',
                    styles['report-chart-ui-header']
                )}
            >
                <TitleWithBody title={props.headerTitle} body={props.headerBody} />
                {props.headerRight ? props.headerRight : null}
            </div>
            {/* This is not visible in the UI, only used for the downloaded report */}
            <div className={classnames('download-chart-header', styles['download-chart-header'])}>
                <Title>{props.downloadReportTitle}</Title>
            </div>
        </div>
    );
}
